import { Button } from '@cloudflare/kumo';
import type { ComponentProps } from 'react';

/**
 * Botão destrutivo: `danger` = preenchido, `dangerOutline` = só contorno.
 * Usa as variantes `destructive` e `secondary-destructive` do Kumo.
 */

export interface DangerButtonProps extends Omit<ComponentProps<typeof Button>, 'variant'> {
  variant?: 'danger' | 'dangerOutline';
}

export function DangerButton({ variant = 'danger', ...props }: DangerButtonProps) {
  return <Button variant={variant === 'danger' ? 'destructive' : 'secondary-destructive'} {...(props as ComponentProps<typeof Button>)} />;
}
